<div class="container-fluid">
    <!-- Content Row -->
    <div class="row">
        <div class="col-xl-12 col-lg-12">
            <div class="all-leads">
                <div class="card shadow mb-4">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h3>Sales Data</h3>
                            <div class="right-search">
                              <input type="text" class="form-control d-inline-block" style="width: 200px;" placeholder="Search">
                                    <label for="Sort by:">Sort by:</label>
                                    <select class="form-control d-inline-block ml-2" style="width: 150px;">
                                        <option>Monthly</option>
                                        <option>Weekly</option>
                                        <option>Daily</option>
                                    </select>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover">
                            <thead class="">
                                <tr>
                                <th scope="col"><input type="checkbox"></th>
                                <th scope="col">Product Name</th>
                                <th scope="col">Customer</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Status</th>
                                <th scope="col">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let item of salesData ">
                                <td><input type="checkbox"></td>
                                <td>{{item.productName || 'N/A'}}</td>
                                <td>{{item.customerName || 'N/A'}}</td>
                                <td>{{item.amount || 'N/A'}}</td>
                                <td><span class="badge badge-success">Completed</span></td>
                                <td>{{item.createdAt | date: 'dd-MM-yyyy' || 'N/A'}}</td>
                            </tr>
                            </tbody>
                            </table>
                        </div>
                        <div *ngIf="salesData.length === 0" class="alert alert-info mt-3">
                            <p>No sales data available.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
